import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';

// English is built in; register German for runtime language switching in Angular pipes.
registerLocaleData(localeDe);
